import React, { createContext, useState, useEffect } from "react";

// Create context
export const LightModeContext = createContext();

export const LightModeContextProvider = ({ children }) => {
  // Default to dark mode if no value is saved in localStorage
  const [isLightMode, setIsLightMode] = useState(
    localStorage.getItem("lightMode")
      ? JSON.parse(localStorage.getItem("lightMode"))
      : false  // Dark mode is true by default when isLightMode is false
  );

  // Toggle between light and dark mode
  const toggle = () => {
    setIsLightMode(prev => !prev);
  };

  // Store the preference in localStorage
  useEffect(() => {
    localStorage.setItem("lightMode", JSON.stringify(isLightMode));
  }, [isLightMode]);

  return (
    <LightModeContext.Provider value={{ isLightMode, toggle }}>
      {children}
    </LightModeContext.Provider>
  );
};
